import React from 'react';
import { all_routes } from '../../router/all_routes';
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb';

const AddService = () => {
  const routes = all_routes;

  const breadcrumbs = [
    { label: 'Dashboard', link: routes.home1, active: false },
    { label: 'Add Service', active: true },
  ];

  return (
    <>
      <Breadcrumb
        title="Add Service"
        breadcrumbs={breadcrumbs}
        backgroundClass="breadcrumb-bg-02"
      />

      {/* Page Wrapper */}
      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <form className="card shadow-none">
                <div className="card-header">
                  <h5 className="fs-18">Service Details</h5>
                </div>
                <div className="card-body pb-1">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Name of Service</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter the service name"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Description</label>
                        <textarea
                          className="form-control"
                          rows={4}
                          placeholder="Enter a brief description of the service"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button type="reset" className="btn btn-light me-2">Reset</button>
                  <button type="submit" className="btn btn-primary">Add Service</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default AddService;
